var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.927,
    height: 150,
    viewBox: "0 0 126.927 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-notifications-outline",
    "data-name": "Icon ionic-md-notifications-outline",
    d: "M69.449,29.506c2.554,0,8.622,1.615,8.622,1.615,16.439,3.767,28.01,18.908,28.01,36v46.014l3.361,3.376,2.808,2.821H25.927l2.808-2.821,3.361-3.376V67.125c0-17.095,11.571-32.237,28.01-36,0,0,6.506-1.615,8.622-1.615m.361-26.131a11.024,11.024,0,0,0-11.2,11.25v5.25a48.612,48.612,0,0,0-37.332,47.25v41.25l-14.932,15v7.5H132.552v-7.5l-14.932-15V67.125a48.612,48.612,0,0,0-37.332-47.25v-5.25a11.024,11.024,0,0,0-11.2-11.25Zm14.932,135H54.156a14.933,14.933,0,1,0,29.865,0Z",
    transform: "translate(-5.625 -3.375)",
    fill: "#fffbf5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.2a69b6480a0645d23763201096f3da9f.svg";
export { ForwardRef as ReactComponent };